import { ThunkType } from "../../../../core/store/reducers";
import getAllRolesAPI from "../api/getAllUsers";
import { setData } from "../usersDataReducer";

export const loadAllUsers = (): ThunkType => async (dispatch, getStore) => {
	const store = getStore();

	if (store.data.auth.current.status !== "successful") {
		return;
	}

	dispatch(setData());

	const { userId } = store.data.auth.current.user;
	const users = await dispatch(getAllRolesAPI(userId));

	dispatch(setData(users || []));
};
